import axios from 'axios';
import getConfig from '../config';

const { indexerApi } = getConfig();

// eslint-disable-next-line no-return-await
export default async (body) => await axios.post(indexerApi, JSON.stringify(body)).then((data) => data)
  .catch((error) => {
    console.log(error.response.data());
  });
